import { render, staticRenderFns } from "./CartItemBill.vue?vue&type=template&id=264d8faa&scoped=true&"
import script from "./CartItemBill.vue?vue&type=script&lang=js&"
export * from "./CartItemBill.vue?vue&type=script&lang=js&"
import style0 from "./CartItemBill.vue?vue&type=style&index=0&id=264d8faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d8faa",
  null
  
)

export default component.exports